/* SPH – Beratungsbox und Muster-Banner nebeneinander (Desktop) */
(function () {
  var help = document.querySelector('.sph-help');
  var ban = document.querySelector('.sph-mb');
  if (!help || !ban) return;

  var helpWrap = help.parentNode;
  var banSec = ban.closest('.shopify-section') || ban;

  var row = document.createElement('div');
  row.className = 'sph-duo';

  helpWrap.parentNode.insertBefore(row, helpWrap);
  row.appendChild(helpWrap);
  row.appendChild(banSec);

  helpWrap.classList.add('sph-duo__a');
  banSec.classList.add('sph-duo__b');
})();
